import { useEffect, useState } from "react";

export const usePathCoordinates = () => {
  const path = window.location.pathname;
  const [coordinates, setCoordinates] = useState<{
    lat: string;
    lng: string;
  } | null>(null);

  useEffect(() => {
    const match = path.match(/\/(-?\d+\.\d{4}),(-?\d+\.\d{4})/);
    if (match) {
      setCoordinates({ lat: match[1], lng: match[2] });
    }
  }, [path]);

  return coordinates;
};
